import { render, staticRenderFns } from "./pai_map.vue?vue&type=template&id=7129b694&scoped=true&"
import script from "./pai_map.vue?vue&type=script&lang=js&"
export * from "./pai_map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7129b694",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7129b694')) {
      api.createRecord('7129b694', component.options)
    } else {
      api.reload('7129b694', component.options)
    }
    module.hot.accept("./pai_map.vue?vue&type=template&id=7129b694&scoped=true&", function () {
      api.rerender('7129b694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/addon/land/tabs/pai_map.vue"
export default component.exports